module.exports = __webpack_public_path__ + "static/media/html-simple-icon.48d9ea68.svg";